import { useParams, Navigate } from "react-router-dom";
import progressGr16 from "@/reports/progress-gr1-6-2023-07/index.js";
import progressGr78 from "@/reports/progress-gr7-8-2023-07/index.js";
import provincialGr16 from "@/reports/provincial-gr1-6-2023-09/index.js";
import provincialGr78 from "@/reports/provincial-gr7-8-2023-09/index.js";
import provincialGr912 from "@/reports/provincial-gr9-12-2022-02-sem/index.js";

const PAGE_BY_KEY = {
  [progressGr16.key]:    progressGr16.Page,
  [progressGr78.key]:    progressGr78.Page,
  [provincialGr16.key]:  provincialGr16.Page,
  [provincialGr78.key]:  provincialGr78.Page,
  [provincialGr912.key]: provincialGr912.Page,
};

export default function FreeTrialReportEditor() {
  const { reportType } = useParams();
  const Page = PAGE_BY_KEY[reportType];

  if (!Page) return <Navigate to="/free-trial" replace />;

  return <Page />;
}
